// Shared reel links live on their own site, share.crowds.cl — a page rendered
// by the `sharePage` function (functions-share/), with the Open Graph tags
// link previews need. The admin app no longer hosts one; its old
// `/share/:shareId` route only forwards here.
//
// Overridable for staging (VITE_SHARE_URL in .env.staging). The webapp builds
// the same URL in webapp/src/services/reelShare.js — a separate repo, so a
// copy; keep them in step.
export const SHARE_BASE = import.meta.env.VITE_SHARE_URL || 'https://share.crowds.cl'

// `shareId` is a `shared/{id}` document id, e.g. `r_<reelId>`.
export function shareUrl(shareId) {
  return `${SHARE_BASE}/${encodeURIComponent(shareId)}`
}
